"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedVariantStore = void 0;
var set_query_string_1 = __importDefault(require("set-query-string"));
var zustand_1 = require("zustand");
var ga4_utils_1 = require("./ga4-utils");
exports.useSelectedVariantStore = (0, zustand_1.create)(function (set, get) { return ({
    variant: undefined,
    change: function (_a) {
        var newVariant = _a.newVariant, emitViewItemEventToGa = _a.emitViewItemEventToGa;
        // if we have some bad code that updates the variant to the same variant we already have, don't
        // emit another GA event
        var currentVariant = get().variant;
        // console.debug({ emitViewItemEventToGa, newVariant, currentVariant })
        if (emitViewItemEventToGa && newVariant && (newVariant === null || newVariant === void 0 ? void 0 : newVariant.id) !== (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.id)) {
            (0, ga4_utils_1.emitViewItemGa4Event)([newVariant], window.currency);
        }
        // update this store's state
        set(function () { return ({ variant: newVariant }); });
        // perform side effects to update non-React dom elements
        // update the query string
        if (newVariant) {
            (0, set_query_string_1.default)({ variant: newVariant.id });
        }
        // update the images carousel and carousel background
        $(document).ready(function () {
            if (newVariant && window.pdpImageIndexes) {
                var filter = window.pdpImageIndexes[newVariant.id].map(function (idx) { return ":eq(".concat(idx, ")"); }).join(',');
                window.pdpCarousel.slick('slickUnfilter');
                window.pdpCarousel.slick('slickFilter', filter);
            }
            var pdpHexEl = document.getElementById('pdp-hex');
            if (newVariant && pdpHexEl) {
                pdpHexEl.style.backgroundColor = window.pdpHexes[newVariant.id];
            }
        });
        // update ingredients
        if (newVariant && typeof window.changeSelectedVariantForIngredients !== 'undefined') {
            window.changeSelectedVariantForIngredients(newVariant);
        }
    },
    initialized: false,
    initialize: function (_a) {
        var initialVariant = _a.initialVariant, emitViewItemEventToGa = _a.emitViewItemEventToGa;
        var initialized = get().initialized;
        if (initialized)
            return;
        if (emitViewItemEventToGa && initialVariant) {
            (0, ga4_utils_1.emitViewItemGa4Event)([initialVariant], window.currency);
        }
        set(function () { return ({ variant: initialVariant }); });
    },
}); });
